"use strict";

exports.__esModule = true;
exports.BaseHistoryFetcher = void 0;
var _rxjs = require("rxjs");
class BaseHistoryFetcher {
  constructor(configs) {
    this.configs = void 0;
    this.fetchParams = void 0;
    this.forceUpdate = void 0;
    this.configs = configs;
    this.forceUpdate = new _rxjs.BehaviorSubject(0);
    this.fetchParams = null;
  }
  process() {
    return (0, _rxjs.combineLatest)({
      timer: (0, _rxjs.timer)(0, this.configs.poolInterval),
      forceUpdate: this.forceUpdate
    }).pipe((0, _rxjs.switchMap)(() => {
      return (0, _rxjs.from)((async () => {
        if (!this.fetchParams) return;
        return this.fetch(this.fetchParams);
      })());
    }));
  }
  reflesh() {
    this.forceUpdate.next(this.forceUpdate.value + 1);
  }
  subscribeHistories(params) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.fetchParams = params;
    this.forceUpdate.next(this.forceUpdate.value + 1);
    return this.process().pipe((0, _rxjs.filter)(i => Array.isArray(i)));
  }
  getHistories(params) {
    return (0, _rxjs.firstValueFrom)(this.subscribeHistories(params));
  }
}
exports.BaseHistoryFetcher = BaseHistoryFetcher;